const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the privacy component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('segmentationSelection', ['Categories', '$q', function (Categories, $q) {
  return {
    restrict: 'E',
    scope: {
      group: '=',
      type: '@'
    },
    template: require('../../../templates/directives/access_profile/segmentation-selection.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var types = $scope.type && $scope.type === 'category' ? ['categories'] : ['locations', 'departments', 'teams', 'org_levels', 'grades'];

      self.searchText = '';
      self.queries = [];

      // Attach legacy name to category in options
      self.legacyName = function(item, type) {
        var parent;
        var parentName;
        var papa;
        var papaName;

        item.text = item.name;
        item.lineage_ids = [item._id];

        if (item.parent) {
          parent = self[type][item.parent];
          parentName = parent.name + ' -> ';
          papa = parent.parent;
          item.text = parentName + item.name;
          item.lineage_ids.push(parent._id);
        }

        if (papa) {
          papa = self[type][papa];
          papaName = papa.name + ' -> ';
          item.text = papaName + parentName + item.name;
          item.lineage_ids.push(papa._id);
        }
      };

      // Sort all categories from api
      self.sortCategories = function(data) {
        var typeMap = {
          location: self.locations,
          department: self.departments,
          team: self.teams,
          org_level: self.org_levels,
          grade: self.grades,
          category: self.categories
        };

        angular.forEach(data, function(cat) {

          var type = cat.location ? 'location' : cat.department ? 'department' : cat.team ? 'team' : cat.org_level ? 'org_level' : cat.grade ? 'grade' : cat.category ? 'category' : '';

          if (!typeMap[type]) {
            return;
          }

          typeMap[type][cat._id] = {
            name: cat.name,
            children: cat.children || null,
            parent: cat.parent || null,
            _id: cat._id,
            type: type
          }
        });

        for (var loc in self.locations) {
          self.legacyName(self.locations[loc], 'locations');
        }
        for (var dep in self.departments) {
          self.legacyName(self.departments[dep], 'departments');
        }
        for (var tea in self.teams) {
          self.legacyName(self.teams[tea], 'teams');
        }
        for (var lev in self.org_levels) {
          self.legacyName(self.org_levels[lev], 'org_levels');
        }
        for (var gra in self.grades) {
          self.legacyName(self.grades[gra], 'grades');
        }
        for (var cat in self.categories) {
          self.legacyName(self.categories[cat], 'categories');
        }
      };

      // Check if any item in lineage is selected
      var checkLineageSelection = function(ids, selections) {
        if (!ids || !ids.length) {
          return false;
        }

        for (var i = 0; i < ids.length; i++) {
          if (selections.indexOf(ids[i]) !== -1) {
            return true;
          }
        }

        return false;
      };

      // Get category options based on input
      self.getOptions = function(input) {
        var deferred = $q.defer();
        input = input ? input.toLowerCase().replace(',', '.*') : '';
        setTimeout(function() {
          var items = [];
          input = input ? input.toLowerCase() : '';

          var placeholders = {
            locations: {name: 'Locations', text: 'Locations', _id: 'locations', placeholder: true},
            departments: {name: 'Departments', text: 'Departments', _id: 'departments', placeholder: true},
            teams: {name: 'Teams', text: 'Teams', _id: 'teams', placeholder: true},
            org_levels: {name: 'Level', text: 'Level', _id: 'org_levels', placeholder: true},
            grades: {name: 'Grade', text: 'Grade', _id: 'grades', placeholder: true},
            categories: {name: 'Category', text: 'Category', _id: 'categories', placeholder: true}
          };
          var addedItems = {};

          types.forEach(function(type) {
            for (var item in self[type]) {
              if (new RegExp(input).test(self[type][item].name.toLowerCase())) {
                if ($scope.type !== 'category' && checkLineageSelection(self[type][item].lineage_ids, $scope.group[type])) {
                  continue;
                }

                if ($scope.type === 'category' && checkLineageSelection(self[type][item].lineage_ids, $scope.group)) {
                  continue;
                }

                if (!addedItems[type]) {
                  items.push(placeholders[type]);
                  addedItems[type] = true;
                }

                items.push(self[type][item]);
              }
            }
          });


          deferred.resolve(items);

        }, 50);

        return deferred.promise;
      };

      // Add selection to selections
      self.itemAdding = function(type, item) {
        if (!item || !type) {
          return false;
        }

        self.searchText = '';

        if ($scope.type === 'category') {
          $scope.group.push(item._id);
          return false;
        }

        var pluralType = type + 's';
        $scope.group[pluralType].push(item._id);

        return false;
      };

      self.removeSelection = function(type, item) {
        if ($scope.type === 'category') {
          $scope.group = $scope.group.reduce(function(acc, id) {
            if (id !== item) {
              acc.push(id);
            }

            return acc;
          }, []);
          return;
        }

        $scope.group[type] = $scope.group[type].reduce(function(acc, id) {
          if (id !== item) {
            acc.push(id);
          }

          return acc;
        }, []);  
      };

      self.initialize = function() {
        var query = {
          fields: ['_id', 'name', 'localized_names', 'category', 'location', 'department', 'team', 'org_level', 'grade', 'company', 'level', 'parent', 'children'].join(','),
          $or: '10,location,true,department,true,team,true,org_level,true,grade,true',
          sort: 'name,1'
        };
        if ($scope.type === 'category') {
          query.category = true;
          delete query['$or'];
        }
        Categories.find(query).$promise
        .then(function(data) {
          if (!$scope.group) {
            $scope.group = {};
            if ($scope.type === 'category') {
              $scope.group = [];
            }
          }

          types.forEach(function(type) {
            self[type] = {};
            if (type !== 'categories') {
              $scope.group[type] = $scope.group[type] || [];
            }
          });

          self.sortCategories(data);
        });
      };

      self.initialize();

    }],
    controllerAs: 'seg'
  };
}]);
